import { takeLatest } from "redux-saga";
import { put, call, select } from "redux-saga/effects";
import queryString from "query-string";

import actiontypes from "../actiontypes";
import { history } from "../store";
import checkResponseStatus from "../utils/api";
import * as apicalls from "../api";
import * as selectors from "../selectors";
import * as actions from "../actions";

// Sagas

function* workflowLoadCategories() {
  yield put({ type: actiontypes.LOADING_CATEGORIES });

  const response = yield call(apicalls.loadCategories);
  const json = yield response.json();
  yield put({ type: actiontypes.LOADED_CATEGORIES, payload: json });
}

function* workflowLoadDistricts() {
  yield put({ type: actiontypes.LOADING_DISTRICTS });
  const response = yield call(apicalls.loadDistricts);
  const json = yield response.json();
  yield put({ type: actiontypes.LOADED_DISTRICTS, payload: json });
}

function* workflowSaveInstitution(action) {
  const token = yield select(selectors.userToken);
  let response = {};
  let json = {};
  yield put({ type: actiontypes.SAVING_INSTITUTION });
  try {
    response = yield call(apicalls.saveInstitution, token, action.payload);
    json = yield response.json();
    checkResponseStatus(response);
    yield put({ type: actiontypes.SAVED_INSTITUTION, payload: json });

    const history_obj = {
      ...queryString.parse(location.search),
      saved: true
    };
    yield history.push({
      pathname: `/edit/${json.body._key}`,
      search: "?" + queryString.stringify(history_obj)
    });
  } catch (err) {
    yield put({ type: actiontypes.SAVE_INSTITUTION_FAILED, payload: json });
  }
}

function* workflowSetFilters(action) {
  const history_obj = { ...queryString.parse(location.search) };
  ["freetext", "districts", "categories", "offborders"]
    .filter(prop => action.payload.hasOwnProperty(prop))
    .forEach(prop => {
      history_obj[prop] = action.payload[prop];
    });

  if (
    action.payload.active === null ||
    (!history_obj.freetext &&
      !history_obj.districts.length &&
      !history_obj.categories.length)
  ) {
    delete history_obj.active;
    yield put(actions.setActiveInstitution());
  }

  if (history_obj.offborders === undefined) {
    history_obj.offborders = false;
  }

  yield history.push({
    pathname: "/map",
    search: "?" + queryString.stringify(history_obj)
  });
}

function* workflowEditInstitution(action) {
  yield history.push(`/edit/${action.payload}`);
}

function* workflowSetActiveInstitution(action) {
  yield history.push({
    pathname: "/map",
    search:
      "?" +
      queryString.stringify({
        ...queryString.parse(location.search),
        active: action.payload
      })
  });
}

// Watchers

export function* watchLoadCategories() {
  yield* takeLatest(actiontypes.LOAD_CATEGORIES, workflowLoadCategories);
}

export function* watchLoadDistricts() {
  yield* takeLatest(actiontypes.LOAD_DISTRICTS, workflowLoadDistricts);
}

export function* watchSetFilters() {
  yield* takeLatest(actiontypes.SET_FILTERS, workflowSetFilters);
}

export function* watchEditInstitution() {
  yield* takeLatest(actiontypes.EDIT_INSTITUTION, workflowEditInstitution);
}

export function* watchSaveInstitution() {
  yield* takeLatest(actiontypes.SAVE_INSTITUTION, workflowSaveInstitution);
}

export function* watchSetActiveInstitution() {
  yield* takeLatest(
    actiontypes.SET_ACTIVE_INSTITUTION,
    workflowSetActiveInstitution
  );
}



/** WEBPACK FOOTER **
 ** ./src/sagas/institutions.js
 **/